<div class="row mt-3">
  <div class="col-4">

  </div>

  <div class="col-4"></div>
  <div class="col-4">
    <div class="d-flex align-items-center justify-content-end">
      <button class="btn btn-clear ms-2">
        <i class=" fa-light fa-bell fa-2xl text-primary"></i>
      </button>
      <a href="">
        <div class="img">
          <img src="profile.png" class="img-fluid rounded-circle" alt="" srcset="">
        </div>
      </a>
    </div>
  </div>
</div>
<div class="mt-3">
  <div class="d-flex justify-content-between align-items-center py-3">
    <a [routerLink]="['/home']"><i class="fa fa-light fa-arrow-left fa-xl"></i></a>
  </div>
</div>

<div class="my-3">
  <h3>Payment Method</h3>
</div>
<br>

<div class="my-2">
  <a [routerLink]="['/create-order/confirm/payment_method/transfer']">
    <div class="d-flex align-items-center my-3">
      <h4 class="light-text"><span class="me-3"><i class="fa fa-regular fa-building-columns"></i></span> Bank Transfer</h4>
      <span class="ms-auto"><i class="fa fa-solid fa-angle-right"></i></span>
    </div>
  </a>
</div>

<div class="my-2">
  <div class="d-flex align-items-center my-3">
    <h4 class="light-text"><span class="me-3"><i class="fa fa-regular fa-money-bill"></i></span> Cash</h4>
    <span class="ms-auto"><i class="fa fa-solid fa-angle-right"></i></span>
  </div>
</div>

<div class="my-2">
  <a>
    <div class="d-flex align-items-center my-3">
      <h4 class="light-text"><span class="me-3"><i class="fa fa-regular fa-credit-card"></i></span> Card (POS)</h4>
      <span class="ms-auto"><i class="fa fa-solid fa-angle-right"></i></span>
    </div>
  </a>
</div>
